import React from 'react'
import { AudienceGroups } from '@npm-client-frontends/client-frontends-shared-types'
import { Box, Typography, Divider } from '@mui/material'
import { ContentSet } from '../Header'
import AudienceBox from './AudienceBox'
import { InfoDialog } from '@npm-client-frontends/shared-components'

export const AudienceInfoButton = ({
  userAudienceGroups,
  contentSets,
}: {
  userAudienceGroups: AudienceGroups[]
  contentSets: ContentSet[]
}) => {
  return (
    <InfoDialog
      label="Audience Information"
      title="Subscription Guide"
      buttonSx={{ ml: 2 }}
    >
      <Typography
        variant="body2"
        gutterBottom
        sx={{ mb: 2, '& ul': { padding: 0, listStyle: 'none' } }}
      >
        You're currently subscribed to the following content sets:
        <ul>
          {contentSets.reduce(
            (subs, { abbreviation, title, audienceGroup }) => {
              const group = userAudienceGroups.find(
                (group) => audienceGroup === group,
              )

              if (group) {
                subs.push(
                  <li
                    key={group}
                    style={{
                      fontWeight: 900,
                    }}
                  >{`${abbreviation} - ${title}`}</li>,
                )
              }

              return subs
            },
            [] as Array<JSX.Element>,
          )}
        </ul>
      </Typography>
      {userAudienceGroups.length > 1 && (
        <>
          <Divider sx={{ marginBottom: '10px' }} />
          <Typography variant="body2" gutterBottom sx={{ mb: 2 }}>
            To customize your experience, use the toggles in the toolbar above
            to enable/disable each of your available content sets. Data
            parameters will adjust and NPM Intel will be tagged with the
            corresponding designations:
          </Typography>

          {contentSets.map(({ audienceGroup, title }) => (
            <Box
              key={title}
              sx={{ mb: 1, display: 'flex', alignItems: 'center' }}
            >
              <AudienceBox audiences={[audienceGroup]} />
              <Typography variant="body2" sx={{ ml: 3 }}>
                {title}
              </Typography>
            </Box>
          ))}
        </>
      )}
      <Typography variant="body2" gutterBottom sx={{ mt: 4, mb: 2 }}>
        If you have any questions or concerns please reach out to us at{' '}
        <a href="mailto:help@newprojectmedia.com">help@newprojectmedia.com</a>.
      </Typography>
    </InfoDialog>
  )
}
